import { MapLoadIcon } from '@restworld/utils-common';

// OpenFreeMap vector tiles (OpenMapTiles schema), keyless and free. Loaded by URL rather
// than as a bundled style object: passing the style as an object to react-map-gl/maplibre
// in this build does not kick off the vector-tile requests (only the background renders),
// whereas the hosted URL loads reliably. Providers with the same schema (MapTiler,
// self-hosted PMTiles) are drop-in fallbacks by swapping this URL.
export const DEFAULT_MAP_STYLE = 'https://tiles.openfreemap.org/styles/liberty';

export const MapScriptLoadingUI = () => (
  <div className="absolute w-full h-full bg-gray-200 flex justify-center items-center">
    <div className="flex flex-col gap-2 items-center w-1/2">
      <span>
        <MapLoadIcon />
      </span>
      <span className="text-gray-500 font-semibold text-lg line-clamp-2 text-center md:w-1/2">
        Stiamo facendo girare il mappamondo...
      </span>
    </div>
  </div>
);
